<template>
  <div class="m-activity-seckill-add">
    <div class="title">基本设置</div>
    <el-form v-if="isEdit" ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="120px">
      <el-form-item label="活动名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入活动名称" />
      </el-form-item>
      <el-form-item label="抢购时间" prop="activityDate">
        <el-date-picker
          v-model="form.activityDate"
          type="datetimerange"
          range-separator=""
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="timestamp"
          format="yyyy/MM/dd HH:mm"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="优惠券" prop="coupons">
        <el-select :disabled="!!$route.query.id" v-model="form.coupons" placeholder="请选择优惠券" @change="v => onCouponChange(v, 'coupon')" multiple collapse-tags filterable>
          <el-option v-for="item in couponListData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div class="coupon-table">
        <Table :tableThData="tableThData_coupon" :tableTrData="tableTrData_coupon" :pagination="false" >
          <template #name="{ row }">{{ row.name }}</template>
          <template #type="{ row }">{{ row.type }}</template>
          <template #detail="{ row }">{{ row.detail }}</template>
          <template #require="{ row }">{{ row.require }}</template>
          <template #useTime="{ row }">{{ row.useTime }}</template>
          <template #sort="{ scope }">
            <el-form-item label-width="0" prop="sort" :rules="[{validator: (r, v, c) => checkPrice(r, v, c, scope, 'tableTrData_coupon')}]">
              <el-input v-model="tableTrData_coupon[scope.$index].sort" placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 80px;" />
            </el-form-item>
          </template>
          <template #price="{ scope }">
            <div class="table-price-box">
              <el-form-item label-width="0" prop="price" :rules="[{validator: (r, v, c) => checkPrice(r, v, c, scope, 'tableTrData_coupon')}]">
                <el-input v-model="tableTrData_coupon[scope.$index].price" placeholder="请输入" oninput="value=value.replace(/[^.\d.]/g,'')" style="width: 100px;" />
                <span class="text">元 +</span>
              </el-form-item>
              <el-form-item label-width="0" prop="point" :rules="[{validator: (r, v, c) => checkPrice(r, v, c, scope, 'tableTrData_coupon')}]">
                <el-input v-model="tableTrData_coupon[scope.$index].point" placeholder="请输入" oninput="value=value.replace(/[^\d]/g,'')" style="width: 100px;" />
                <span class="text">积分</span>
              </el-form-item>
            </div>
          </template>
          <template #amount="{ scope }">
            <el-form-item label-width="0" prop="amount" :rules="[{validator: (r, v, c) => checkPrice(r, v, c, scope, 'tableTrData_coupon')}]" >
              <el-input v-model="tableTrData_coupon[scope.$index].amount" placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 80px;" />
            </el-form-item>
          </template>
          <template #secLimit="{ scope }">
            <el-form-item label-width="0" prop="secLimit" :rules="[{validator: (r, v, c) => checkPrice(r, v, c, scope, 'tableTrData_coupon')}]" >
              <el-input v-model="tableTrData_coupon[scope.$index].secLimit" placeholder="请输入" oninput="value=value.replace(^[0-9]*$,'')" style="width: 80px;" />
            </el-form-item>
          </template>
          <template #refundable="{ scope }">
            <el-form-item label-width="0" prop="refundable" :rules="[{validator: (r, v, c) => checkPrice(r, v, c, scope, 'tableTrData_coupon')}]" >
              <el-radio-group v-model="tableTrData_coupon[scope.$index].refundable">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
        </Table>
      </div>
      <el-form-item label="礼品券" prop="giftCoupons">
        <el-select :disabled="!!$route.query.id" v-model="form.giftCoupons" placeholder="请选择礼品券" @change="v => onCouponChange(v, 'gift')" multiple collapse-tags filterable>
          <el-option v-for="item in giftCouponListData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div class="coupon-table">
        <Table :tableThData="tableThData_gift" :tableTrData="tableTrData_gift" :pagination="false" >
          <template #name="{ row }">{{ row.name }}</template>
          <template #subTitle="{ row }">{{ row.subTitle }}</template>
          <template #useTime="{ row }">{{ row.useTime }}</template>
          <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
          <template #description="{ row }">
            <el-button v-if="row.description" type="text" @click="onLookRemark(row)">查看使用须知</el-button>
            <span v-else>---</span>
          </template>
          <template #sort="{ scope }">
            <el-form-item label-width="0" prop="sort" :rules="[{validator: (r, v, c) => checkPrice(r, v, c, scope, 'tableTrData_gift')}]">
              <el-input v-model="tableTrData_gift[scope.$index].sort" placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 80px;" />
            </el-form-item>
          </template>
          <template #price="{ scope }">
            <div class="table-price-box">
              <el-form-item label-width="0" prop="price" :rules="[{validator: (r, v, c) => checkPrice(r, v, c, scope, 'tableTrData_gift')}]">
                <el-input v-model="tableTrData_gift[scope.$index].price" placeholder="请输入" oninput="value=value.replace(/[^.\d.]/g,'')" style="width: 100px;" />
                <span class="text">元 +</span>
              </el-form-item>
              <el-form-item label-width="0" prop="point" :rules="[{validator: (r, v, c) => checkPrice(r, v, c, scope, 'tableTrData_gift')}]">
                <el-input v-model="tableTrData_gift[scope.$index].point" placeholder="请输入" oninput="value=value.replace(/[^\d]/g,'')" style="width: 100px;" />
                <span class="text">积分</span>
              </el-form-item>
            </div>
          </template>
          <template #amount="{ scope }">
            <el-form-item label-width="0" prop="amount" :rules="[{validator: (r, v, c) => checkPrice(r, v, c, scope, 'tableTrData_gift')}]" >
              <el-input v-model="tableTrData_gift[scope.$index].amount" placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 80px;" />
            </el-form-item>
          </template>
          <template #secLimit="{ scope }">
            <el-form-item label-width="0" prop="secLimit" :rules="[{validator: (r, v, c) => checkPrice(r, v, c, scope, 'tableTrData_gift')}]" >
              <el-input v-model="tableTrData_gift[scope.$index].secLimit" placeholder="请输入" oninput="value=value.replace(^[0-9]*$,'')" style="width: 80px;" />
            </el-form-item>
          </template>
          <template #refundable="{ scope }">
            <el-form-item label-width="0" prop="refundable" :rules="[{validator: (r, v, c) => checkPrice(r, v, c, scope, 'tableTrData_gift')}]" >
              <el-radio-group v-model="tableTrData_gift[scope.$index].refundable">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
        </Table>
      </div>
      <el-form-item label="范围类型" prop="scopeType">
        <el-radio-group v-model="form.scopeType" :disabled="form.hidden">
          <el-radio label="AllMall">所有商场</el-radio>
          <el-radio label="Mall">指定商场</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.scopeType == 'Mall'" prop="mallIds" label="" label-width="270px" >
        <el-select v-model="form.mallIds" placeholder="请选择商场" filterable multiple collapse-tags>
          <el-option v-for="item in mallData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="允许秒杀次数" prop="activitySecLimit" >
        <el-input v-model="form.activitySecLimit" placeholder="请输入秒杀次数" oninput="value=value.replace(/[^\d]/g,'')" style="width: 180px;" />
        <span style="color: #333333; font-size:12px;margin-left:5px">（该次数仅限制单个用户当前场次的可秒杀次数；秒杀次数默认为0，即不限秒杀次数，不为0时即为对应可参与秒杀次数）</span>
      </el-form-item>
    </el-form>
    <div v-else class="base-info">
      <SeckillDetail :detailData="form"></SeckillDetail>
    </div>

    <div v-if="isEdit" class="button-box">
      <el-button @click="onCancel" class="mr20">取消</el-button>
      <el-button type="primary" @click="onNextStep" :loading="submitLoading">完成</el-button>
    </div>
    <div v-else-if="isCanEdit" class="button-box right">
      <auth-button auth="market:activity:update">
        <el-button type="primary" @click="onEdit" :loading="submitLoading">编辑</el-button>
      </auth-button>
    </div>

    <div class="buyer-box" v-if="$route.query.page == 'detail'">
      <el-divider />
      <div class="title">购买记录</div>
      <BuyerRecord v-if="form.id"></BuyerRecord>
    </div>

    <el-dialog :visible="isShowRemarkDialog" title="使用须知" :before-close="() => this.isShowRemarkDialog = false" width="30%">
      <div class="remark-box" v-html="currentRow.description"></div>
    </el-dialog>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import Table from "@/components/Table/index";
import SeckillDetail from './components/detail.vue'
import BuyerRecord from './components/buyerRecord.vue'
import { api_getActivityBaseInfo, api_postSeckillAdd, api_putSeckillUpdate } from '@/api/market'
import { api_getListCoupon, api_getGiftListCoupon , api_getConfig } from '@/api/common'

export default {
  name: "marketActivitySeckillAdd",
  components: {
    AuthButton,
    Table,
    SeckillDetail,
    BuyerRecord
  },
  data() {
    // 校验表格中的输入框
    const checkPrice = (rule, v, callback, scope, tableName) => {
      const { field } = rule
      const { $index } = scope
      const value = this[tableName][$index][field]
      if ((field == 'sort' || field == 'amount') && !value) {
        callback(new Error('请输入'))
      } else if (typeof value !== 'boolean' && field == 'refundable') {
        callback(new Error('请选择'))
      } else if (field == 'sort' && value) {
        let obj = {
          tableTrData_coupon: this.tableTrData_coupon.map(item => item.sort),
          tableTrData_gift: this.tableTrData_gift.map(item => item.sort)
        }
        obj[tableName].splice($index, 1)
        if ([...obj.tableTrData_coupon, ...obj.tableTrData_gift].filter(item => item == value).length) {
          callback(new Error('排序值重复'))
        } else {
          callback()
        }
      } else if (field == 'price' && !value && !this[tableName][$index].point) {
        callback(new Error('售价和积分至少填入一项'))
      } else if (field == 'point' && !value && !this[tableName][$index].price) {
        callback(new Error('售价和积分至少填入一项'))
      } else if (field == 'price' && value && parseFloat(value) === 0 && !parseFloat(this[tableName][$index].point)) {
        callback(new Error('售价和积分不能都为0'))
      } else if (field == 'point' && value && parseFloat(value) === 0 && !parseFloat(this[tableName][$index].price)) {
        callback(new Error('售价和积分不能都为0'))
      } else {
        callback()
      }
    }

    // 校验优惠券和礼品券不能都为空
    const checkCoupon = (rule, value, callback) => {
      const { field } = rule
      if ((field == 'coupons' && !this.form.giftCoupons.length || field == 'giftCoupons' && !this.form.coupons.length) && !value.length) {
        callback(new Error('请至少选择一张优惠券或者礼品券'))
      } else {
        callback()
      }
    }

    // 校验活动时间
    const checkActivityDate = (rule, value, callback) => {
      if (!value || !value.length) {
        callback(new Error('请选择抢购时间'))
      } else {
        callback()
      }
    }

    return {
      loadingID: null,
      submitLoading: false,
      isEdit: true, // 表单是否是编辑状态
      isCanEdit: true, // 活动是否可以编辑
      form: {
        coupons: [],
        giftCoupons: [],
        activitySecLimit:0
      },
      rules: {
        name: [{ required: true, message: '请输入活动名称' }],
        activityDate: [{ validator: checkActivityDate }],
        refundable: [{ required: true, message: '请输入活动名称' }],
        activitySecLimit: [{ required: true, message: '请输入允许秒杀次数' }],
        coupons: [{ validator: checkCoupon }],
        giftCoupons: [{ validator: checkCoupon }],
      },
      checkPrice,
      couponListData: [], // 优惠券list数据
      giftCouponListData: [], // 礼品券list数据
      tableThData_coupon: [
        { prop: "name", label: "优惠券名称", minWidth: "100", },
        { prop: "type", label: "优惠券类型", minWidth: "100", },
        { prop: "detail", label: "券优惠", minWidth: "80", },
        { prop: "require", label: "券门槛", minWidth: "80", },
        { prop: "useTime", label: "用券时间", minWidth: "120", },
        { prop: "sort", label: "排序", minWidth: "100", },
        { prop: "price", label: "价格", minWidth: "300", },
        { prop: "amount", label: "数量", minWidth: "100", },
        { prop: "secLimit", label: "可秒杀次数", minWidth: "100", },
        { prop: "refundable", label: "是否过期自动退", minWidth: "120", },
      ],
      tableTrData_coupon: [],
      tableThData_gift: [
        { prop: "name", label: "礼品券名称", minWidth: "100", },
        { prop: "subTitle", label: "标题", minWidth: "80", },
        { prop: "useTime", label: "券有效时间", minWidth: "100", },
        { prop: "useRangeType", label: "核销范围", minWidth: "80", },
        { prop: "description", label: "使用须知", minWidth: "120", },
        { prop: "sort", label: "排序", minWidth: "100", },
        { prop: "price", label: "价格", minWidth: "300", },
        { prop: "amount", label: "数量", minWidth: "100", },
        { prop: "secLimit", label: "可秒杀次数", minWidth: "100", },
        { prop: "refundable", label: "是否过期自动退", minWidth: "120", },
      ],
      tableTrData_gift: [],
      mallData:[],
      isShowRemarkDialog: false,
      currentRow: {},
      pickerOptions: {
        disabledDate: this.disabledDateFun,
      },
    };
  },
  async created() {
    await this.getCouponListData() // 获取优惠券列表数据
    await this.getGiftCouponListData() // 获取礼品券列表数据
    await this.getConfigData() // 获取config 商场
    this.form.type = this.$route.query.type
    if (this.$route.query.id) {
      this.getDetailData() // 获取详情数据
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.loadingID = this.$baseLoading(6)
    }
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.isEdit = false
      let res = await api_getActivityBaseInfo({id: this.$route.query.id})
      console.log('基本信息res: ', res);

      this.form = {
        ...res,
        activityDate: [res.startTime, res.endTime], // 活动时间
        coupons: res.couponTemplate ? res.couponTemplate.map(item => item.id) : [],
        giftCoupons: res.giftCouponTemplate ? res.giftCouponTemplate.map(item => item.id) : [],
        scopeType: res.mallIds && res.mallIds.length ? 'Mall' : 'AllMall'
      }
      this.tableTrData_coupon = res.couponTemplate || []
      this.tableTrData_gift = res.giftCouponTemplate || []
      if (res.status == 'Doing' || res.status == 'Ended') {
        this.isCanEdit = false
      }
      this.loadingID.close()
    },

    // 获取优惠券列表数据
    async getCouponListData() {
      const res = await api_getListCoupon()
      this.couponListData = res
    },

    // 获取礼品券列表数据
    async getGiftCouponListData() {
      const res = await api_getGiftListCoupon()
      this.giftCouponListData = res
    },

    // 优惠券下拉框改变
    onCouponChange(value, type) {
      if (type == 'coupon') {
        this.$refs.form.validateField('giftCoupons')
        let curCoupon = this.couponListData.filter(item => value.indexOf(item.id) >= 0)
        this.tableTrData_coupon = curCoupon.map(item => {
          let curTable = this.tableTrData_coupon.filter(el => el.id == item.id)
          return curTable.length ? curTable[0] : item
        })
        // 添加可秒杀次数默认值
        // this.tableTrData_coupon.forEach(item =>{
        //   item.secLimit = 0
        // })
        console.log(this.tableTrData_coupon)
      } else {
        this.$refs.form.validateField('coupons')
        let curCoupon = this.giftCouponListData.filter(item => value.indexOf(item.id) >= 0)
        this.tableTrData_gift = curCoupon.map(item => {
          let curTable = this.tableTrData_gift.filter(el => el.id == item.id)
          return curTable.length ? curTable[0] : item
        })
      }
    },

        // 获取config
      async getConfigData() {
      const {mall} = await api_getConfig(['mall'])
      this.mallData = mall // 商场
    },

    // 禁用日期
    disabledDateFun(date) {
      if (this.$moment(date).valueOf() < this.$moment().subtract(1, 'day').valueOf()) {
        return true
      }
    },

    // 点击提交基本信息
    onNextStep() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            let { activityDate } = this.form
            let params = {
              ...this.form,
              startTime: activityDate && activityDate[0] ? activityDate[0] : null,
              endTime: activityDate && activityDate[1] ? activityDate[1] : null,
              couponTemplate: this.disposeCoupons('coupon'),
              giftCouponTemplate: this.disposeCoupons('gift'),
            }

            !params.id && (params.disable = false) // 创建活动时默认状态
            delete params.activityDate // 删除活动时间原始数据
            delete params.coupons
            delete params.giftCoupons
            console.log('params: ', params);
            // return

            let res = params.id ? await api_putSeckillUpdate(params) : await api_postSeckillAdd(params)
            console.log('res: ', res);
            this.$baseMessage('保存成功', 'success')
            this.$router.push({
              query: {
                ...this.$route.query,
                id: res.id
              }
            })
            this.getDetailData()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },

    // 处理优惠券、礼品券保存数据
    disposeCoupons(type) {
      let listData = type == 'coupon' ? this.tableTrData_coupon : this.tableTrData_gift
      return listData.map(item => {
        const { id, sort, price, point, amount, refundable,secLimit } = item
        return {
          id,
          sort,
          price: price || '0',
          point: point || '0',
          amount,
          secLimit: secLimit || '0',
          refundable
        }
      })
    },

    // 查看使用须知
    onLookRemark(row) {
      this.currentRow = row
      this.isShowRemarkDialog = true
    },

    // 点击编辑按钮
    onEdit() {
      this.isEdit = true
    },

    // 点击取消
    onCancel() {
      if (this.$route.query.id) {
        this.isEdit = false
      } else {
        this.$router.back(-1)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.m-activity-seckill-add {
  width: 100%;
  padding: 35px 20px;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;

  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }

  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }

  .coupon-table {
    width: 90%;
    margin-left: 120px;
    margin-bottom: 20px;

    .table-price-box {
      width: 400px;
      display: flex;

      .text {
        width: 40px;
        height: 34px;
        line-height: 34px;
        margin: 0 10px;
      }

      // .el-form-item {
      //   background: #ccc;

      //   .el-form-item__content {
      //     display: flex !important;

      //     .text {
      //       height: 34px;
      //       line-height: 34px;
      //       margin: 0 10px;
      //     }
      //   }
      // }
    }
  }


  .row-info {
    min-height: 34px;
    line-height: 34px;
    margin-bottom: 20px;
    font-size: 14px;

    .col-label {
      text-align: right;
      padding-right: 20px;
      color: #666;
    }

    .col-value {
      color: #000;
    }
  }

  .winning-record {
    margin-top: 60px;

    .el-divider {
      margin-bottom: 20px;
    }
  }
  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }

    .title-remark {
      color: #666666;
      font-size: 14px;
    }
  }

  .button-box{
    text-align: left;
    margin-top: 50px;

    &.right {
      text-align: right;
    }
  }
}
</style>
